import { render, staticRenderFns } from "./fail-whale.vue?vue&type=template&id=4439d23e&scoped=true&"
import script from "./fail-whale.vue?vue&type=script&lang=js&"
export * from "./fail-whale.vue?vue&type=script&lang=js&"
import style0 from "./fail-whale.vue?vue&type=style&index=0&id=4439d23e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4439d23e",
  null
  
)

export default component.exports